function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.714 30.928l4.41-1.474 4.411 2.622 4.411-1.665 4.41 2.143 4.411-2.143 4.411 1.665 4.41-2.622L46 30.928l-3.715 21.357c-9.397 3.02-18.06 2.913-27.857 0z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "square",
  strokeWidth: 1.002
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.357 32.268l.173 22.41M37.436 32.076l-1.272 21.645M19.44 31.712l1.36 22.009"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.152 31.121C8.152 29.849 7 28.351 7 26.749c0-2.42 2.722-4.09 6.923-5.13m28.792-.107c4.461 1.032 6.999 2.732 6.999 5.237 0 1.668-1.25 3.222-3.402 4.527"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.837 11.937c5.852 1.403 9.913 5.446 9.913 8.777 0 4.103-6.444 4.643-14.393 4.643-7.949 0-14.393-.54-14.393-4.643 0-3.311 4.198-7.326 9.997-8.752"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 10.5a4.643 4.643 0 11-9.286 0 4.643 4.643 0 019.286 0z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 5.857c-1.506-4.26-4.41-4.61-7.429-4.643"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.445 25.579c-.094-3.643-.905-6.716-2.87-10.544M40.556 24.057c-2.344-3.781-4.132-7.846-8.64-10.526M24.27 25.579c.093-3.643.905-6.716 2.87-10.544M16.158 24.057c2.345-3.781 4.133-7.846 8.64-10.526"
}));

var SvgCupcake = function SvgCupcake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCupcake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cupcake.3a643685.svg";
export { ForwardRef as ReactComponent };